import React from 'react'
import classNames from 'classnames'
import styleModule from './swiper-button2.module.scss'

interface IProps {
  type?: 'prev' | 'next'
  className?: string
  clkTeaParams?: string
  style?: React.CSSProperties
  onClick?: () => void
}

const SwiperButton2 = React.forwardRef<HTMLButtonElement, IProps>(
  ({ type, className = '', clkTeaParams, style, onClick }, ref) => {
    return (
      <React.Fragment>
        <button
          style={style}
          type={'button'}
          ref={ref}
          className={classNames(
            'swiper-button2',
            styleModule['swiper-button2'],
            className,
            type
          )}
          data-log-click={clkTeaParams}
          onClick={onClick}
        >
          <i
            className={classNames('DCD_Icon tw-text-20', {
              icon_triangle_right: type === 'next',
              icon_triangle_left: type === 'prev',
            })}
          />
        </button>
        <style jsx global>
          {`
            .swiper-transition-wrapper {
              position: relative;
              overflow: hidden;
            }
            .swiper-transition-wrapper :global(.swiper-button2) {
              transition: ease-in-out 0.2s;
              opacity: 0;
            }
            .swiper-transition-wrapper :global(.swiper-button2.prev) {
              transform: translateX(-100%);
            }
            .swiper-transition-wrapper :global(.swiper-button2.next) {
              transform: translateX(100%);
            }
            .swiper-transition-wrapper:hover :global(.swiper-button2) {
              opacity: 1;
              transform: translateX(0);
            }
          `}
        </style>
      </React.Fragment>
    )
  }
)

export default SwiperButton2
